<template>
  <div>
    <div v-if="value.phoneNumber.length > 0 && value.phoneNumber[0].number">
      <p v-for="item in value.phoneNumber" class="text-right clickable link-tag cursor-pointer"
         @click="rangMe(item.number)">
        <v-icon color="red">mdi-phone-outline</v-icon>
        : {{ item.text || '' }} {{ item.number }}
      </p>
    </div>

    <p v-if="value.companyNumber" class="text-right cursor-pointer" @click="rangMe(value.companyNumber)">
      <span class="font-weight-bold"><span> <v-icon color="red">mdi-phone-outline</v-icon> : </span></span>
      <span class="link-tag" dir="ltr">{{ value.companyNumberName }} {{ value.companyNumber | persianNum }}</span>
    </p>

    <p v-if="value.fax" class="text-right">
      <v-icon :color="fontColor">mdi-fax</v-icon>
      :
      <span dir="ltr">{{ value.fax | persianNum }}</span>
    </p>
    <!--    <p v-if="value.workField" class="text-right">-->
    <!--      <span class="font-weight-bold"><span><v-icon :color="'black'">mdi-license</v-icon></span>: </span>-->
    <!--      {{ value.workField |persianNum }}-->
    <!--    </p>-->

    <a :href="`mailto:${value.email}`" :style="value.pallete.textColor" target="_blank">
      <p v-if="value.email" :style="value.pallete.textColor" class="text-right pt-1 clickable link-tag cursor-pointer">
        <span><v-icon color="red">mdi-email-outline</v-icon></span>
        : {{ value.email }}
      </p>
    </a>
    <p v-if="value.website" class="text-right pb-3 link-tag cursor-pointer" @click="goToUrl(value.website)">
      <span><v-icon color="blue">mdi-earth</v-icon></span> :
      {{ value.website }}
    </p>

    <p v-if="value.location" class="text-right">
      <v-icon :color="fontColor">mdi-map-marker</v-icon>
      :
      <span dir="ltr">{{ value.location }}</span>
    </p>

    <p v-if="value.codePostal" class="text-right">
      <v-icon :color="fontColor">mdi-post</v-icon>
      :
      <span dir="ltr">{{ value.codePostal | persianNum }}</span>
    </p>
  </div>
</template>

<script>
export default {
  name: "numbersShow",
  props: {
    value: Object,
    fontColor: String
  },
  methods: {
    goToUrl(url, pattern = null) {
      let setUrl = ''
      const emailRegex = /\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}\b/i;

      if (!url.startsWith('http')) {
        if (emailRegex.test(url)) setUrl = 'mailto:'
        else if (pattern) setUrl = pattern.startsWith('http') ? pattern : 'https://' + pattern
        else setUrl = 'https://'
      }

      let a = document.createElement('a')
      a.setAttribute('href', setUrl + url)
      a.setAttribute('target', '_blank')
      a.click()
    },
    rangMe(url) {
      let a = document.createElement('a')
      a.setAttribute('href', `tel:${url}`)
      a.click()
    },
  }
}
</script>

<style scoped>

</style>